import styled from 'styled-components';

const Tab = styled.div`
  cursor: pointer;
  font-weight: bold;
  text-align: center;
  color: ${({theme, selected}) => (selected ? theme.white : theme.primaryColor)};
  background-color: ${({theme, selected}) => (selected ? theme.primaryColor : theme.white)};
  padding: ${({theme}) => theme.spacingVertical()} ${({theme}) => theme.spacingHorizontal(2)};
  font-size: ${({theme}) => theme.fontSmall};
`;

export default Tab;
